import { Component, OnInit, Input, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Ward } from '../Models/Ward';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';
import { filter } from 'rxjs/operators';
import { ImportStationsComponent } from 'src/app/import-stations/import-stations.component';
import { invalid } from 'moment';
import { CheckStorageService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';

@Component({
  selector: 'lib-ph-bhp-configure-ward',
  templateUrl: './ph-bhp-configure-ward.component.html',
  styleUrls: ['./ph-bhp-configure-ward.component.css']
})
export class PhBhpConfigureWardComponent implements OnInit, OnDestroy {
  private unassignedWebKessWards;
  readonly departmentColumnFieldName: string = "departmentName"
  readonly departmentTypeColumnFieldName: string = "departmentTypeName"
  readonly mappedWardColumnFieldName: string = "mappedWardId"
  subscription: Subscription;
  unSubscription: Subscription;
  gridData: any[];
  fields: any[];
  importWebkessButton: any;
  mapMigratedWardsButton: any;
  institutionID: number;
  @Input() institutions: any;
  @Input() userData: any;
  itemChange: boolean = false;
  InstitutionsList: [any];
  modalRef: BsModalRef;
  searchText;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('activeModal') activeModal: TemplateRef<any>;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('confirmModal') confirmModal: TemplateRef<any>;
  @ViewChild('confirmMapWardsModal') confirmMapWardsModal: TemplateRef<any>;
  @ViewChild('unlinkModal') unlinkModal: TemplateRef<any>;
  @ViewChild('grid') grid: any;

  navigationSubscription: Subscription;
  selectedInstitution
  selectedInstitutionName
  deleteDataItem
  deleterowIndex
  unlinkDataItem
  pageInfo
  selected = null;
  isCreateWardEnabled = true
  configData: any;
  wardModelGridEdit: any = new UntypedFormGroup({
    wardName: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(50)])),
    //HHP-211 - Restore this code for mapped ward
    //mappedWardId: new FormControl('', Validators.compose([Validators.maxLength(60)])),
    departmentID: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)])),
  });
  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });
  mappedMigratedWards: boolean = false;
  wards: any[];
  showWardMappingButton: boolean = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  downloadWardsButton: any = {
    buttonText: TranslationKeys.Webkess.DownloadWards,
    isActive: true,
    deactivatedTooltip: TranslationKeys.Webkess.DownloadWardsDisabled,
    onClick: () => { this.showDownloadWebkessConfirmationModal(this.confirmModal) },
  };

  actionItems: any = [
    { name: 'CONFIGURE.EDIT', imgSrc: 'assets/ph-bhp-layout/svg/icon-edit.svg', isEdit: true, onClick: (dataItem) => { this.openUnlinkModal(this.unlinkModal, dataItem); } },
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem); } },
  ];


  constructor(private router: Router,
    public route: ActivatedRoute,
    public configService: PHBHPFeaturePackageConfigurationService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public appConfig: AppConfig,
    private checkStorageService: CheckStorageService) { }

  ngOnInit() {

    this.layoutService.showLoader = true;

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.getdepartmant();
        this.getDepartmentType();
        this.getWardList(this.layoutService.institutionID);
      }
    });

    this.getdepartmant();
    this.getDepartmentType();
    this.fields = [
      {
        'field': 'wardName', 'title': TranslationKeys.Configure.Ward,
        editTemplate: {
          type: 'text',
          maxLength: 50,
          validator: (dataItem) => {
            if (dataItem.wardName != null && dataItem.wardName != '') {
              return true;
            }
            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.WARD_NAME'));
            return false;
          }
        }
      },
      {
        'field': this.departmentColumnFieldName, 'title': TranslationKeys.Configure.Department,
        editTemplate: {
          type: 'dropdown',
          textField: this.departmentColumnFieldName, // must be the same as the field name
          valueField: 'departmentID',
          validator: (dataItem) => {
            if (dataItem.departmentID != null && dataItem.departmentID != '') {
              return true;
            }

            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.DEPARTMENT'));
            return false;
          }
        }
      },
      {
        'field': this.departmentTypeColumnFieldName, 'title': 'CONFIGURE.DEPARTMENT_TYPE',
        editTemplate: {
          type: 'dropdown',
          textField: this.departmentTypeColumnFieldName, // must be the same as the field name
          valueField: 'departmentTypeID',
          defaultValue: 1,
          validator: (dataItem) => {
            if (dataItem.departmentTypeID != null && dataItem.departmentTypeID != '') {
              return true;
            }

            this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.DEPARTMENT_TYPE'));
            return false;
          }
        }
      },
      {
        field: "isActiveValue",
        title: "CONFIGURE.WARD_IS_ACTIVE",
        editTemplate: {
          type: "checkbox",
          textField: "",
          valueField: "isActive",
          validText: 'CONFIGURE.ACTIVE',
          invalidText: 'CONFIGURE.INACTIVE',
          isChecked: (ward: any) => { 
            return ward.isActive; 
          }
        },
      }
    ];

    this.loadWebkessField();

    this.pageInfo = {
      items: 'CONFIGURE.WARDS',
      itemsPerPageLabel: 'CONFIGURE.PER_PAGE.WARDS'
    };

    this.importWebkessButton =
    {
      buttonText: TranslationKeys.Webkess.DownloadWards,
      isActive: true,
      deactivatedTooltip: TranslationKeys.Webkess.DownloadWardsDisabled,
      onClick: () => { this.mappedMigratedWards = false; this.showDownloadWebkessConfirmationModal(this.confirmModal) },
    }

    this.mapMigratedWardsButton = {
      buttonText: 'map migrated wards',
      isActive: true,
      deactivatedTooltip: 'map migrated wardss disabled',
      onClick: () => { this.mappedMigratedWards = true; this.showMapWardsConfirmationModal(this.confirmMapWardsModal) },
    }

    this.getConfigData(null);
    this.unSubscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.getConfigData(null);
      this.getWardList(this.layoutService.institutionID);
      this.loadWebkessField();
      this.grid.ngOnInit();
    });

    this.subscription = this.layoutService.lang.asObservable().subscribe(selectedLang => {
      this.getdepartmant()
    });

  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    if (this.unSubscription)
      this.unSubscription.unsubscribe();
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  loadWebkessField() {
    if (this.layoutService.institutionWebkess) {
      this.fields.push(
        {
          'field': 'webkessWardName',
          'title': TranslationKeys.Webkess.WebkessWard
        }
      );
    } else {
      this.fields = this.fields.filter(field => field.field !== 'webkessWardName');
    }
  }

  getdepartmant() {
    this.configService.getDepartmentList().subscribe((res) => {
      this.institutions = this.appConfig.institutions;

      //HHP-211 To restored mapped ward field. Set field position to 2 for department field.
      this.fields[1].ngTemplate = (dataItem) => {
        var department = res.find(x => { return x.departmentID == dataItem.departmentID });
        return (department) ? department.departmentName : '';
      };
      this.fields[1].editTemplate.data = res;
      this.OnInstitutionsChanges()
      this.changeLangFordepart()
      //Sort alphabetically
      this.fields[1].editTemplate.data.sort((a, b) => a.departmentName.localeCompare(b.departmentName));

    })
  }

  getDepartmentType() {
    this.configService.getDepartmentTypeList().subscribe((res) => {
      //HHP-211 To restored mapped ward field. Set field position to 2 for department field.
      this.fields[2].ngTemplate = (dataItem) => {
        var departmentType = res.find(x => { return x.departmentTypeID == dataItem.departmentTypeID });
        return (departmentType) ? departmentType.departmentTypeName : '';
      };

      this.fields[2].editTemplate.data = res;
      this.OnInstitutionsChanges();
      this.changeLangForDepartmentType();
      //Sort alphabetically
      this.fields[2].editTemplate.data.sort((a, b) => a.departmentTypeName.localeCompare(b.departmentTypeName));

    })
  }

  openmodal(template: TemplateRef<any>) {
    this.mygroup.patchValue({
      selectedIns: this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' })
    )
  }

  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      this.itemChange = true;
      var roleId = this.appConfig.userData.roleName.roleId
      this.configService.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        if (this.layoutService.institutionID) {
          this.institutionID = this.layoutService.institutionID;
        } else {
          if (res.length > 0) {
            this.institutionID = res[0].institution.institutionID;
          }
        }
        this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === this.institutionID).institution;
        this.onInstitutionChange(this.institutionID);
      })
    }

  }

  changeGridLang() {
    this.gridData.forEach((value, index) => {
      this.gridData[index].departmentName = this.layoutService.translateText(value.departmentName);
      this.gridData[index].departmentTypeName = this.layoutService.translateText(value.departmentTypeName);
    });
  }
  onInstitutionChange(value) {
    if (this.InstitutionsList) {
      this.getWardList(value);
      this.layoutService.institutionID = value;
      this.selected = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionID;
      this.selectedInstitutionName = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionName;
      this.getConfigData(value);
    }
  }

  getWardList(value) {
    this.layoutService.showLoader = true;
    this.configService.getWardsbyInstitutionId(value).subscribe((wards: any[]) => {
      this.layoutService.showLoader = false;
      this.wards = wards;
      for (let i = 0; i < wards.length; i++) {
        if (!this.wards[i].iswebKessStation) {
          this.wards[i].webkessWardName = null;
        }
      }
      this.updateGridButtonsVisibility(wards)
      this.gridData = wards;
      this.gridData = this.gridData.map(ward => this.manageGrid(ward));
      this.changeGridLang();
    })
  }

  manageGrid(ward) {
    ward.isActiveValue = ward.isActive ? this.layoutService.translateText('CONFIGURE.ACTIVE') : this.layoutService.translateText('CONFIGURE.INACTIVE');
    return ward;
  }

  setUnassignedWebKessWards(allWards: any[]) {
    this.unassignedWebKessWards = this.getUnassignedWards(allWards).map(ward => ({ wardName: ward.wardName, mappedWardId: ward.wardID }))
  }

  private getUnassignedWards(allWards: any[]) {
    let webKessWardIdsAlreadyMapped = allWards.filter(ward => ward.iswebKessStation !== true && ward.mappedWardId != null).map(ward => ward.mappedWardId)
    let unAssignedWebKessWards = allWards.filter(ward => ward.iswebKessStation === true && !webKessWardIdsAlreadyMapped.includes(ward => ward.mappedWardId == ward.wardID))
    return unAssignedWebKessWards;
  }

  private isWardMappedToWebKessWard(allWards: any[], ward: any): Boolean {
    return allWards.find(ward2 => ward.mappedWardId == ward2.wardID) === undefined;
  }

  private updateAssignableWebKessWards(mappedWardId: number) {
    if (mappedWardId) {
      this.unassignedWebKessWards = this.unassignedWebKessWards.filter(ward => mappedWardId != ward.mappedWardId)
      this.fields[1].editTemplate.data = this.unassignedWebKessWards
    }
  }

  changeLangFordepart() {
    //HHP-211 To restored mapped ward field. Set field position to 2 for department field.
    this.fields[1].editTemplate.data.forEach((value, index) => {
      value.departmentName = this.layoutService.translateText(value.departmentName);
    });
  }

  changeLangForDepartmentType() {
    this.fields[2].editTemplate.data.forEach((value, index) => {
      value.departmentTypeName = this.layoutService.translateText(value.departmentTypeName);
    });
  }


  handlerData({ handler, formGroup, isNew, dataItem, rowIndex }): boolean {
    this.userData = this.appConfig.userData;
    switch (handler) {
      case 'saveHandler':
        var userId = this.userData.userId;

        var wardData: any = {};
        wardData.wardName = dataItem.wardName;
        wardData.departmentID = +dataItem.departmentID;
        wardData.institutionID = +this.layoutService.institutionID;
        wardData.isDeleted = false;
        wardData.isActive = dataItem.isActive;
        wardData.departmentTypeID = dataItem.departmentTypeID;
        if (isNew) {
          wardData.createdBy = userId;
          this.configService.createWard(wardData).subscribe((res: Ward) => {
            // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.WARD'));
            this.getWardList(wardData.institutionID);
          });
        }
        else if (!isNew) {
          wardData.wardID = dataItem.wardID;
          wardData.webkessWardName = dataItem.webkessWardName;
          this.configService.updateWard(dataItem.wardID, wardData).subscribe((res: Ward) => {
            this.gridData[rowIndex].wardName = wardData.wardName;
            this.gridData[rowIndex].departmentID = wardData.departmentID;
            this.gridData[rowIndex].isActive = wardData.isActive;
            this.gridData = this.gridData.map(ward => this.manageGrid(ward));
          });
        }
        //HHP-211 - Restore this code for mapped ward
        //this.updateAssignableWebKessWards(wardData.mappedWardId);
        break;

      case 'removeHandler':
        this.openDeleteModal(this.delmodal, dataItem, rowIndex);
        break;
    }
    return true
  }

  removeLink(dataItem) {
    this.openUnlinkModal(this.unlinkModal, dataItem);
  }

  openUnlinkModal(unlinkModal: TemplateRef<any>, dataItem) {
    this.unlinkDataItem = dataItem
    this.modalRef = this.modalService.show(unlinkModal, Object.assign({}, { class: 'w-420' })
    )
  }

  unlink() {

    this.unlinkDataItem.webkessWardName = null;
    this.unlinkDataItem.iswebKessStation = false;
    this.unlinkDataItem.actionId = -1;
    this.unlinkDataItem.createdBy = this.appConfig.userData.userId;
    this.configService.updateWard(this.unlinkDataItem.wardID, this.unlinkDataItem).subscribe((res: Ward) => {
      let wards: any[] = JSON.parse(JSON.stringify(this.gridData));
      this.gridData = wards;
      this.wards = wards;
      this.gridData = this.gridData.map(ward => this.manageGrid(ward));
      this.updateGridButtonsVisibility(wards)
    })
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem, rowIndex?) {
    this.deleteDataItem = dataItem
    this.deleterowIndex = rowIndex ? rowIndex : null;
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  delete() {
    this.layoutService.showLoader = true;
    this.configService.deleteWard(this.deleteDataItem.wardID).subscribe((res: Ward) => {
      this.checkStorageService.deleteChecksByWardId(this.deleteDataItem.wardID).subscribe((deletedChecks) => {
        let wards: any[] = JSON.parse(JSON.stringify(this.gridData));
        this.gridData = [];
        var index = this.deleterowIndex ? this.deleterowIndex : wards.findIndex(ward => ward.wardID === this.deleteDataItem.wardID);
        wards.splice(index, 1);
        this.gridData = wards;
        this.gridData = this.gridData.map(ward => this.manageGrid(ward));
        this.updateGridButtonsVisibility(wards);
      }, (error) => {}, () => { this.layoutService.showLoader = false; });
    }, (error) => {}, () => { this.layoutService.showLoader = false; })
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }

  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  onSelectedValue(event) {
    this.gridData[event.rowIndex].iswebKessStation = true;

    if (event.fieldName == this.departmentColumnFieldName)
      this.gridData[event.rowIndex].departmentID = event.selectedValue;

    if (event.fieldName == this.mappedWardColumnFieldName)
      this.gridData[event.rowIndex].mappedWardID = event.selectedValue;
  }

  showDownloadWebkessConfirmationModal(confirmModal) {
    if (this.importWebkessButton && this.importWebkessButton.isActive)
      this.modalRef = this.modalService.show(confirmModal, Object.assign({}, { class: 'w-420' }))
    else
      this.layoutService.showError(this.layoutService.translateText(TranslationKeys.Webkess.DownloadWardsDisabled))
  }

  showMapWardsConfirmationModal(confirmMapWardsModal) {

    if (this.mapMigratedWardsButton.isActive) {
      this.modalRef = this.modalService.show(confirmMapWardsModal, Object.assign({}, { class: 'w-420' }))
    } else {

      this.layoutService.showError(this.layoutService.translateText(''))
    }
  }

  /**
   * Sets visibility for 'New ward' and 'Import webkess'
   * @param wards Grid wards list
   */
  private updateGridButtonsVisibility(wards: any[]) {
    if (!!this.importWebkessButton) {
      this.importWebkessButton.isActive = this.isImportWebkessEnabled(wards);
    }
    this.isCreateWardEnabled = true; // HHP-1040 > Must be always enabled.
    this.mapMigratedWardsButton.isActive = this.isMigratedWardsMappingEnabled(wards);
  }

  private isMigratedWardsMappingEnabled(wards: any[]): boolean {
    if (this.selectedInstitution && this.selectedInstitution.v2Preexist) {
      // the every function no apply because if all fields are null returns true;
      // return wards.every(w => w.v2MappedWard);
      let allMapped = true;
      wards.forEach(w => {
        if (w.v2MigrationId && !w.v2MappedWard) {
          allMapped = false;
        }
      })
      this.showWardMappingButton = !allMapped;
      return !allMapped;
    } else {
      this.showWardMappingButton = false;
      return false;
    }
  }

  /**
   *
   * @param wards Determines 'Import webkess' button visibility
   * @returns True if user institution is enabled and a webKess connection is established
   */
  private isImportWebkessEnabled(wards: any[]): boolean {
    let iswebKessConnectionEstablished = this.configData.iswebKessConnectionEstablished && this.appConfig.userData.roleName.roleId == 4;
    let isInstitutionAdmin = this.appConfig.userData.roleName.roleId == 4;
    return iswebKessConnectionEstablished && isInstitutionAdmin;
  }

  /**
  *
  * @param wards Determine 'New ward' button visibility
  * @returns True if user institution is not enabled with Kiss surveillance or user has some personalized wards already created
  */
  private isCreatePersonalizedWardEnabled(wards: any[]): boolean {
    let isKissSurveillanceEnabled = this.configData.enableHandKissSurveillance && this.appConfig.userData.roleName.roleId == 4
    if (wards && wards.length != 0) {
      let allWardsAreWebkess = wards.every(ward => ward.iswebKessStation === true)
      return !allWardsAreWebkess || !isKissSurveillanceEnabled
    }
    else {
      return !isKissSurveillanceEnabled
    }
  }

  private getConfigData(institutionId) {
    if (this.configData && !!institutionId) {
      this.activeWebkessDownload();
      return this.configData;
    } else {
      if (this.layoutService.institutionID && this.configService) {
        this.configService.getConfigDetails(this.layoutService.institutionID).subscribe(
          (res: any) => {
            this.configData = res;
            this.activeWebkessDownload();
          })
      }
    }
  }

  activeWebkessDownload() {
    if (this.InstitutionsList) {
      var isWebKessActivated = this.InstitutionsList.find(i => i.institution.institutionID == this.layoutService.institutionID).institution.activateWebKess;
      var isWebKessConnectionEstablished = this.configData.iswebKessConnectionEstablished;
      if (isWebKessActivated && isWebKessConnectionEstablished) {
        this.importWebkessButton = this.downloadWardsButton;
      } else {
        this.importWebkessButton = null;
      }
    }
  }

  mapMigratedWards(event) {
    this.layoutService.importStationsClicked = true;

    const wards = this.wards.filter(ward => { return ward.v2MappedWard != 1 && ward.v2NewWard == 1 });
    const wardsToMap = this.wards.filter(ward => { return ward.v2MappedWard != 1 });
    let initialState = {
      service: this.configService,
      data: this.layoutService,
      mapMigratedWards: this.mappedMigratedWards,
      wards,
      wardsToMap
    };
    this.modalService.show(ImportStationsComponent, { initialState, class: 'modal-full w-full modal-dialog-scrollable' });
  }

  importStations(event) {
    this.layoutService.importStationsClicked = true;
    let initialState = {
      service: this.configService,
      data: this.layoutService,
      mapMigratedWards: this.mappedMigratedWards,
      wards: this.wards
    };
    this.modalService.show(ImportStationsComponent, { initialState, class: 'modal-full w-full' });
    // this.router.navigateByUrl('/importstations');
  }

  addNew() {
    if (!this.grid.isNew) {
      this.gridData.unshift({
        "wardID": 0,
        "institutionID": this.layoutService.institutionID,
        "departmentID": 0,
        "wardName": "",
        "webkessWardName": "",
        "isDeleted": false,
        "isActive": true,
        "departmentName": "",
        "iswebKessStation": false,
        "mappedWard": null,
        "v2MigrationId": null,
        "v2MigrationOldName": null,
        "v2MigrationOldDept": null,
        "v2MigrationOldType": null,
        "v2MappedWard": null,
        "v2NewWard": null,
        "departmentTypeID": 1,
        "departmentTypeName": ""
      });
      this.grid.editRowIndex = 0;
      this.grid.editItem = {};
      this.grid.isNew = true;
      this.grid.changeValue(true, 0, 'isActive', 'check');
      this.grid.changeValue(true, 0, 'isActiveValue', 'check');
      this.grid.updateGrid();
    }
  }

}
